<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <!-- <div class="row">
        <div class="col">
          <div class="d-flex align-items-center justify-content-end">
              <date-picker class="date-picker" v-model="time3" range></date-picker>
              <button class="btn glob-btn">Search</button>
            </div> 
        </div>
      </div> -->
      <b-popover target="popover-target-2" triggers="hover" placement="Right">
      <div>
      <b>Description</b>
      <p class="mb-0">
       Kapitman's corner is the home of our fundamental leaning company research reports.
        Here, you'll get to know about the company's financial performance and prospects,
         investment highlights, and risks. Suitable for investors with long term horizons.
        </p>
        </div>
      </b-popover>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-8">
          <div class="p-3 border-right">
              <h5><i class="bi bi-info-circle-fill text-primary pop-info-icon" id="popover-target-2"></i>
              Kapitman's Corner</h5>
            <h2 class="main-title">{{KapitmansCorner.title}}</h2>
            <p class="text-muted">Posted on {{FormatDate(KapitmansCorner.date)}}</p>
            <table class="table table-bordered stock-reco-card">
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="4" class="text-center">Stock Recommendation</th>
                </tr>
              </thead>
     
              <tbody>
                <tr>
                  <td class="text-center">
                    Stock
                    <h4 class="stock-label">{{KapitmansCorner.stockRecommendations.stockSymbol}}</h4>
                  </td>
                  <td class="text-center">
                    Entry Price
                    <h4 class="stock-label">{{KapitmansCorner.stockRecommendations.entryPrice}}</h4>
                  </td>
                  <td class="text-center">
                    Target Price
                    <h4 class="stock-label">{{KapitmansCorner.stockRecommendations.targetPrice}}</h4>
                  </td>
                  <td class="text-center">
                    Potential Upside
                    <h4 class="stock-label">{{KapitmansCorner.stockRecommendations.potentialUpside}}</h4>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="overview">
              <!-- <h5 class="sub-title-page">{{KapitmansCorner.kapitmansCornerArticle.articleSubtitle}}</h5> -->
              
              <p class="text-muted" v-html="KapitmansCorner.stockRecommendations.article">
                
              </p>
              
           
              <div class="button-container">
                <router-link to="/KapitmansCorner/Archive">
                         More Reports
                </router-link>

              
              </div>
            </div> 
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <div class="p-3">
            <!-- <div class="d-flex align-items-center">
              <input type="text" class="form-control" />
              <b-button class="glob-btn btn">Search</b-button>
            </div> -->
            <h5 class="sub-title-page">Stock Recommendation</h5>
            <KapitsmanStockReco />
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col">
          <h5 class="sub-title-page">Dividends</h5>

          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Upcoming Dividends" active>
                <div class="table-responsive">

                    <div v-for="(item, index) in upcomingDividends.templates" :key="index">
     <div class="table table-umbraco-upcoming mt-0 mb-0" v-if="item.contentType == 'table'">
                <p v-html="item.content"></p>
              </div>
              </div>
                  <!-- <table class="table secondary-table table-bordered text-nowrap">
                    <thead>
                      <tr>
                        <th>Stock</th>
                        <th>Company</th>
                        <th>Type of Security</th>
                        <th>Type of Dividends</th>
                        <th>Dividends Payment</th>
                        <th>Ex-Date</th>
                        <th>Record Date</th>
                        <th>Payment Date</th>
                      </tr>
                    </thead>
                    <tbody v-for="(items, index) in reports.upcomingDividends" :key="index">
                      <tr>
                        <td>{{items.stockSymbol}}</td>
                        <td>{{items.company}}</td>
                        <td>{{items.typeOfSecurity}}</td>
                        <td>{{items.typeOfDividends}}</td>
                        <td>{{items.dividendsPayment}}</td>
                        <td>{{FormatDate(items.date)}}</td>
                        <td>{{FormatDate(items.recordDate)}}</td>
                        <td>{{FormatDate(items.paymentDate)}}</td>
                      </tr>
                    
                    </tbody>
                  </table> -->
                  <!-- <b-skeleton-table
                :rows="10"
                :columns="8"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table> -->
                </div>
              </b-tab>
              <b-tab title="Preferred Shares (Yield)"
                >
                 <div class="table-responsive">
                  <table class="table secondary-table table-bordered text-nowrap">
                    <thead>
                       <tr>
                  <th>Stock</th>
                  <th>Company</th>
                  <th>Dividend Per Period</th>
                  <th>Offer Price</th>
                  <th>Annualized Div Yield (Offer)</th>
                  <th>Current Price</th>
                   <th>Annualized Div Yield (Current)</th>
                  <th>Prospectus</th>
                </tr>
              </thead>
            <tbody >
                   <tr  v-for="(item, index) in preferredShares.preferredShares" :key="index">
                  <td>{{item.stock}}</td>
                  <td>{{item.company}}</td>
                  <td class="text-right">{{item.dividendPerPeriod}}</td>
                   <td class="text-right">{{ FormatPrices(item.offerPrice) }}</td>
                    <td class="text-right">{{ FormatYield(item.annualizedDividendYeildOffer) }} %</td>
                    <td class="text-right">{{ FormatPrices(item.currentPrice) }} </td>
                    <td class="text-right">{{ FormatYield(item.annualizedDividendYeildCurrent) }} %</td>
                  <td class="text-center">
                    <!-- {{item.prospectus}} -->
                      <a target="_blank" :href="item.prospectus"
                        ><i class="bi bi-filetype-pdf"></i
                      ></a>
                     
                  </td>

                </tr>
               </tbody>
                  </table>
                  <!-- <b-skeleton-table
                :rows="10"
                :columns="8"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table> -->
                </div>
                </b-tab
              >
              <b-tab title="REITs">
                 <div class="table-responsive">
                 <table class="table secondary-table table-bordered text-nowrap">
              <thead>
           
                <tr>
                  <th>Stock</th>
                  <th>Company</th>
                  <th>Dividend Per Period</th>
                  <th>Offer Price</th>
                  <th>Annualized Div Yield (Offer)</th>
                  <th>Current Price</th>
                   <th>Annualized Div Yield (Current)</th>
                  <th>Prospectus</th>
                </tr>
              </thead>
            <tbody>
                   <tr v-for="(item, index) in reitsDividends.reits" :key="index">
                  <td>{{item.stock}}</td>
                  <td>{{item.company}}</td>
                  <td class="text-right">{{item.dividendPerPeriod}}</td>
                   <td class="text-right">{{ FormatPrices(item.offerPrice) }}</td>
                    <td class="text-right">{{ FormatYield(item.annualizedDividendYeildOffer) }} %</td>
                    <td class="text-right">{{ FormatPrices(item.currentPrice) }} </td>
                    <td class="text-right">{{ FormatYield(item.annualizedDividendYeildCurrent) }} %</td>
                  <td class="text-center">
                    <!-- {{item.prospectus}} -->
                      <a target="_blank" :href="item.prospectus"
                        ><i class="bi bi-filetype-pdf"></i
                      ></a>
                    </td>
                </tr>
               </tbody>
            </table>
             <!-- <b-skeleton-table
                :rows="10"
                :columns="8"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table> -->
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <TradingStrategies v-show="false" />
      <InvestingStrategies v-show="false" />
    </div>
       <Footer />
  </div>
</template>

<script>
import navHeader from "../ResearchPages/NavHeader.vue";
import Footer from "../ResearchPages/Footer";
import KapitsmanStockReco from "../ResearchPages/KapitmansStockReco.vue";
import TradingStrategies from "../ResearchPages/TradingStrategies";
import InvestingStrategies from "../ResearchPages/InvestingStrategies";
import { mapState } from "vuex";
 import moment from "moment";

export default {
  components: {
    navHeader,
    Footer,
    KapitsmanStockReco,
    TradingStrategies,
    InvestingStrategies
  },

 data() {
    return {
        isDataLoaded:false,
        time3:""
    }
  },

 computed: {
    ...mapState({
       KapitmansCorner: (state) => state.philstocksResearch.kapitsmanCornerContent,
       reitsDividends: (state) => state.philstocksResearch.ReportsContent.reits,
       preferredShares: (state) => state.philstocksResearch.ReportsContent.preferredShares,
       upcomingDividends: (state) => state.philstocksResearch.ReportsContent.upcomingDividends,
    }),
  },
  methods: {
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
    FormatPrices(data) {
      var price = parseFloat(data);
      if (price == 0) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else if (price < 0.51) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        });
      } else if (price >= 1000) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    FormatYield(data) {
      var price = parseFloat(data);
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },

   async GetKapitmanContent() {
      var isResponseError = false;
      this.isDataLoaded =  true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetHomeContent")
        .catch(function (error) {
          console.log(error);
         _this.isDataLoaded =  false;

           isResponseError = false;
        });

      if (!isResponseError) {
       _this.isDataLoaded =  false;
      } 
    },
 
  },

 async mounted() {
    this.GetKapitmanContent();
    this.$store.dispatch("philstocksResearch/GetReportsContent");
  },

};
</script>

<style>
</style>